<template>
  <div>
    <div class="artcol_top_bar">
      <span
        v-if="shouldShowBackButton"
        class="artcol_tip"
        @click="goToArticleCollection"
        >文章收藏</span
      >
      <span v-else class="artcol_tip artcol_tip_noac" @click="goTome"
        >个人中心</span
      >
      <i class="el-icon-arrow-right"></i>
      <span class="artcol_tip" @click="clsmag">分类管理</span>
    </div>

    <div style="margin-top: 30px">
      <el-collapse v-model="activeNames">
        <el-collapse-item v-for="item in tpList" :name="0">
          <template slot="title">
            <div class="tp_head_con">
              <span class="tp_head_title">{{ item.name }}</span>
              <div class="tp_head_btns_con">
                <span
                  class="tp_head_tp_add_btn"
                  @click="openAddSortDialog(item.id)"
                >
                  <span class="tp_head_tp_add_inbtn">新增</span>
                </span>
                <!-- 绑定删除一级分类方法 -->
                <span
                  class="tp_head_tp_sub_btn"
                  @click="deleteFirstSort(item.id, item.name, -1)"
                >
                  <span class="tp_head_tp_sub_inbtn">删除</span>
                </span>
                <!-- 绑定更新一级分类方法 -->
                <span
                  class="tp_head_tp_mod_btn"
                  @click="openUpdateSortDialog(item.id, item.name, -1)"
                >
                  <span class="tp_head_tp_mod_inbtn">修改</span>
                </span>
              </div>
            </div>
          </template>
          <div>
            <div class="tp_in_item" v-for="initem in item.inList">
              <span style="margin-left: 100px">{{ initem.name }}</span>
              <div class="tp_head_btns_con" style="margin-right: 80px">
                <span
                  class="tp_head_tp_add_btn"
                  @click="moveSecondSort(initem.id, initem.name)"
                >
                  <span class="tp_head_tp_add_inbtn">移动</span>
                </span>
                <!-- 绑定删除二级分类方法 -->
                <span
                  class="tp_head_tp_sub_btn"
                  @click="deleteSecondSort(initem.id, initem.name, item.id)"
                >
                  <span class="tp_head_tp_sub_inbtn">删除</span>
                </span>
                <!-- 绑定更新二级分类方法 -->
                <span
                  class="tp_head_tp_mod_btn"
                  @click="openUpdateSortDialog(initem.id, initem.name, item.id)"
                >
                  <span class="tp_head_tp_mod_inbtn">修改</span>
                </span>
              </div>
            </div>
          </div>
          <!--  -->
        </el-collapse-item>
      </el-collapse>
      <div>
        <!-- 点击按钮，展示对话框 -->
        <el-button type="primary" @click="openAddSortDialog(-1)"
          >添加一级分类</el-button
        >
      </div>

      <!-- 对话框组件 -->
      <el-dialog title="添加一级分类" :visible.sync="showDialog">
        <el-input v-model="addSortName" placeholder="请输入分类名称"></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showDialog = false">取消</el-button>
          <el-button type="primary" @click="addFirstLevelSort">确认</el-button>
        </span>
      </el-dialog>

      <!-- 对话框组件 - 添加分类 -->
      <el-dialog title="添加分类" :visible.sync="showAddDialog">
        <el-input
          v-model="newAddSortName"
          placeholder="请输入分类名称"
        ></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showAddDialog = false">取消</el-button>
          <el-button type="primary" @click="performAddSort">确认</el-button>
        </span>
      </el-dialog>

      <!-- 对话框组件 - 修改分类 -->
      <el-dialog title="修改分类" :visible.sync="showUpdateDialog">
        <el-input v-model="newUpdateSortName" placeholder="请输入新的分类名称">
          {{ newUpdateSortName }}
        </el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showUpdateDialog = false">取消</el-button>
          <el-button type="primary" @click="performUpdateSort">确认</el-button>
        </span>
      </el-dialog>

      <el-dialog title="选择一级分类" :visible.sync="showMoveSortDialog">
        <el-select
          v-model="selectedTargetFirstLevelId"
          placeholder="请选择一级分类"
        >
          <el-option
            v-for="firstLevel in tpList"
            :key="firstLevel.id"
            :label="firstLevel.name"
            :value="firstLevel.id"
          >
          </el-option>
        </el-select>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeButton">取消</el-button>
          <el-button type="primary" @click="performMoveSort">移动</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  articleCollect,
  GetFirstLevelClassification,
  GetSecondLevelClassification,
  addTopSort,
  addSort,
  deleteSort,
  updateSort,
} from "@/api/article";
export default {
  name: "clsmag",
  data() {
    return {
      firstLevelClass: [],
      firstLevelClassSelected: "",
      allSecondLevelClass: [],
      secondLevelClass: [],
      secondLevelClassSelected: "",

      userId: 1,
      showDialog: false,
      addSortName: "",
      activeNames: 0,
      showAddDialog: false,
      showUpdateDialog: false,
      newAddSortName: "",
      newUpdateSortName: "",
      selectedSortId: null,
      selectedParentSortId: null,

      shouldShowBackButton: false, // 默认不显示

      showMoveSortDialog: false, // 控制移动对话框的显示
      selectedTargetFirstLevelId: null, // 用户选择的目标一级分类ID
      movingSecondLevelSortId: null, // 正在移动的二级分类ID
      movingSecondLevelSortName: null,
      tpList: [
        /* {
						id:1,
						name:"军事电子",
						inList: [
							{
								id:1,
								name:"先进电子"
							},
							{
								id:2,
								name:"先进制造"
							}
						]
					},
				 */
      ],
    };
  },
  mounted() {
    console.log(this.$route.params);
    if (this.$route.params.back) {
      this.shouldShowBackButton = true;
    }
    console.log(this.$store.getters.getUserInfo);
    let that = this;

    GetFirstLevelClassification({
      userId: this.userInfo.id || 1,
    }).then((res) => {
      that.firstLevelClass.splice(0, that.firstLevelClass.length);
      that.firstLevelClassSelected = "";
      console.log("===============");
      console.log(res);
      res.data.forEach((item) => {
        that.firstLevelClass.push(item);
        const arr = that.allSecondLevelClass.filter(
          (secondLevelItem) => secondLevelItem.parentId == item.sortId
        );
        console.log("arr", arr);
        //that.tpList.splice(0, that.tpList.length);
        that.tpList.push({
          id: item.sortId,
          name: item.sortName,
          inList: arr.map((secondLevelItem) => ({
            id: secondLevelItem.sortId,
            name: secondLevelItem.sortName,
          })),
        });
        console.log(that.tpList);
      });
    });

    GetSecondLevelClassification({
      userId: this.userInfo.id || 1,
    }).then((res) => {
      that.allSecondLevelClass.splice(0, that.secondLevelClass.length);
      that.secondLevelClassSelected = "";
      console.log("===============");
      console.log(res);

      res.data.forEach((item) => {
        that.allSecondLevelClass.push(item);
      });
      console.log("allSecondLevelClass", that.allSecondLevelClass);
    });
    this.loadFirstLevelClassification();
  },
  methods: {
    goTome() {
      this.$router.push({ name: "me" });
    },
    goToArticleCollection() {
      this.$router.push({ name: "artcol" });
    },

    changeFirstLevelClass() {
      this.secondLevelClass.splice(0, this.secondLevelClass.length);
      console.log(this.firstLevelClassSelected);
      const arr = this.allSecondLevelClass.filter(
        (item) => item.parentId == this.firstLevelClassSelected
      );
      console.log(arr);
      arr.forEach((item) => {
        this.secondLevelClass.push(item);
      });
    },
    addFirstLevelSort() {
      let that = this;
      console.log("sss");
      console.log(that.addSortName);
      addSort({
        sortName: this.newAddSortName,
        parentSortId: -1,
        userId: this.userInfo.id || 1,
      }).then((res) => {
        console.log(res);

        // 清空输入框，并关闭对话框
        that.addSortName = "";
        that.showDialog = false;

        // 重新加载分类
        that.loadFirstLevelClassification();
      });
    },
    loadFirstLevelClassification() {
      let that = this;
      GetFirstLevelClassification({
        userId: this.userInfo.id || 1,
      }).then((resFirstLevel) => {
        // ...处理一级分类...
        GetSecondLevelClassification({
          userId: this.userInfo.id || 1,
        }).then((resSecondLevel) => {
          // ...处理二级分类...
          // 确保 tpList 更新
          that.tpList = resFirstLevel.data.map((firstLevelItem) => {
            const secondLevelItems = resSecondLevel.data.filter(
              (secondItem) => secondItem.parentId === firstLevelItem.sortId
            );
            return {
              id: firstLevelItem.sortId,
              name: firstLevelItem.sortName,
              inList: secondLevelItems.map((secondItem) => ({
                id: secondItem.sortId,
                name: secondItem.sortName,
              })),
            };
          });
        });
      });
    },
    openAddSortDialog(parentSortId) {
      this.newAddSortName = "";
      this.selectedParentSortId = parentSortId;
      this.showAddDialog = true;
    },

    openUpdateSortDialog(sortId, sortName, parentSortId) {
      this.newUpdateSortName = sortName;
      this.selectedSortId = sortId;

      this.selectedParentSortId = parentSortId;
      this.showUpdateDialog = true;
    },
    clsmag() {
      var that = this;

      that.$router.push({ name: "clsmag", params: { refresh: true } });
    },
    performAddSort() {
      if (!this.newAddSortName.trim()) {
        alert("分类名称不能为空");
        return;
      }
      console.log("tianjia ", this.newAddSortName);
      addSort({
        sortName: this.newAddSortName,
        parentSortId: this.selectedParentSortId,
        userId: this.userInfo.id || 1,
      }).then((res) => {
        // 处理添加分类后的逻辑
        this.showAddDialog = false;
        this.loadFirstLevelClassification();
        this.$message.success("添加分类成功");
      });
    },

    performUpdateSort() {
      if (!this.newUpdateSortName.trim()) {
        alert("分类名称不能为空");
        return;
      }
      updateSort({
        sortId: this.selectedSortId,
        sortName: this.newUpdateSortName,
        parentSortId: this.selectedParentSortId,
        userId: this.userInfo.id || 1,
      }).then((res) => {
        // 处理修改分类后的逻辑
        this.showUpdateDialog = false;
        this.$message.success("更新成功");
        this.loadFirstLevelClassification();
      });
    },
    deleteSecondSort(sortId, sortName, parentSortId) {
      let that = this;
      deleteSort({
        sortId: sortId,
        sortName: sortName,
        parentSortId: parentSortId,
        userId: this.userInfo.id || 1,
      }).then((res) => {
        this.loadFirstLevelClassification();
        this.$message.success("删除成功");
      });
    },
    deleteFirstSort(sortId, sortName, parentSortId) {
      deleteSort({
        sortId: sortId,
        sortName: sortName,
        parentSortId: parentSortId,
        userId: this.userInfo.id || 1,
      }).then((res) => {
        this.loadFirstLevelClassification();
        this.$message.success("删除成功");
      });
    },
    moveSecondSort(secondSortId, secondSortName) {
      this.movingSecondLevelSortId = secondSortId;
      this.movingSecondLevelSortName = secondSortName;
      this.showMoveSortDialog = true; // 显示对话框
    },
    performMoveSort() {
      if (!this.selectedTargetFirstLevelId) {
        this.$message.error("请选择一个目标一级分类");
        return;
      }
      if (!this.movingSecondLevelSortId) {
        this.$message.error("请选择一个要移动的二级分类");
        return;
      }
      updateSort({
        sortId: this.movingSecondLevelSortId,
        sortName: this.movingSecondLevelSortName,
        parentSortId: this.selectedTargetFirstLevelId,
        userId: this.userInfo.id || 1,
      })
        .then((res) => {
          // 成功的逻辑处理
          this.$message.success("更新成功");
        })
        .finally(() => {
          // 错误处理
          this.closeButton();
          this.loadFirstLevelClassification();
        });
    },
    closeButton() {
      (this.showMoveSortDialog = false), // 控制移动对话框的显示
        (this.selectedTargetFirstLevelId = null), // 用户选择的目标一级分类ID
        (this.movingSecondLevelSortId = null); // 正在移动的二级分类ID
        this.movingSecondLevelSortName = null;
    },
  },
  computed: {
    userInfo() {
      return this.$store.getters.getUserInfo;
    },
  },
};
</script>

<style>
.artcol_tip {
  font-size: 18px;
  color: #2683be;
  cursor: pointer;
}
.artcol_tip_noac {
  color: #707070 !important;
}
.tp_in_item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-right: 50px;
  border-bottom: solid 1px #e6e6e6;
  border-top: solid 1px #e6e6e6;
  padding-top: 12px;
  padding-bottom: 12px;
  font-size: 16px;
}

.tp_head_tp_mod_inbtn {
  border: solid 1px #468bbf;
  color: #468bbf;
  font-size: 16px;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 2px;
  padding-bottom: 2px;
}

.tp_head_tp_mod_btn {
  line-height: 25px;
  border: solid 1px #468bbf;
  padding-left: 2px;
  padding-right: 2px;
  margin-left: 10px;
  cursor: pointer;
}

.tp_head_tp_sub_inbtn {
  border: solid 1px #29d4b2;
  color: #29d4b2;
  font-size: 16px;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 2px;
  padding-bottom: 2px;
}

.tp_head_tp_sub_btn {
  line-height: 25px;
  border: solid 1px #29d4b2;
  padding-left: 2px;
  padding-right: 2px;
  margin-left: 10px;
  cursor: pointer;
}

.tp_head_tp_add_inbtn {
  border: solid 1px #cdb48d;
  color: #cdb48d;
  font-size: 16px;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 2px;
  padding-bottom: 2px;
}

.tp_head_tp_add_btn {
  line-height: 25px;
  border: solid 1px #cdb48d;
  padding-left: 2px;
  padding-right: 2px;
  margin-left: 10px;
}

.tp_head_btns_con {
  display: flex;
  align-items: center;
}

.tp_head_title {
  color: #262626;
  font-size: 18px;
  font-weight: 550;
  margin-left: 20px;
}

.tp_head_con {
  display: flex;
  align-items: center;
  justify-content: space-between !important;
  width: 100% !important;
  margin-right: 60px;
}
</style>
